import { FC } from 'react';
import { Modal, ModalSize } from '@spotted-zebra-uk/ui-components';
import InviteNewCandidate from './InviteNewCandidate';

interface IDirectInvitationModal {
  projectId: number;
  projectSubId: string;
  stageSubId: string;
  onClose: () => void;
}

const DirectInvitationModal: FC<IDirectInvitationModal> = ({
  projectId,
  projectSubId,
  stageSubId,
  onClose,
}) => {
  return (
    <Modal
      isOpen
      header="Invite via email"
      className="direct-invitation-modal"
      modalSize={ModalSize.SMALL}
      onClose={onClose}
    >
      {
        <InviteNewCandidate
          projectId={projectId}
          projectSubId={projectSubId}
          stageSubId={stageSubId}
          closeModal={onClose}
        />
      }
    </Modal>
  );
};

export default DirectInvitationModal;
